// We read this from env variable to support templating during the build process
import { ASSET_PREFIX, CDN_URL, CDN_URL_TEMPLATE, IS_DEPLOYED } from '../../constants'

export const withPublicAssetUrl = (asset: string): string => {
  return IS_DEPLOYED ? `${CDN_URL}${ASSET_PREFIX}/public/${asset}` : `/static/${asset}`
}

export const withSharedAssetUrl = (asset: string): string => {
  return IS_DEPLOYED ? `${CDN_URL}/shared/${asset}` : `/static/${asset}`
}

export const withSharedAssetUrlCSS = (asset: string): string => {
  return IS_DEPLOYED ? `${CDN_URL_TEMPLATE}/shared/${asset}` : `/static/${asset}`
}

export const withPublicAssetUrlCSS = (asset: string): string => {
  return IS_DEPLOYED ? `${CDN_URL_TEMPLATE}${ASSET_PREFIX}/public/${asset}` : `/static/${asset}`
}
